import { EnvironmentNames } from "@origin-digital/platform-enums";
import { logger } from "@origin-digital/reporting-client";
import Survicate from "@survicate/survicate-web-package/survicate_widget";
import { fetchMarketingId } from "@origin-digital/event-dispatcher";
import { getApiKey } from "./utils/config";
import { SurvicateCustomEvent } from "./utils/types";

export type InvokeSurvicateEvent = (
  eventName: SurvicateCustomEvent,
  eventProperties?: Record<string, string>
) => void;

export const invokeSurvicateEvent: InvokeSurvicateEvent = (
  eventName,
  eventProperties
) => {
  logger.info("[survicate] custom event", { eventName, eventProperties });
  Survicate.invokeEvent(eventName, eventProperties);
};

export const setVistorAttributesEvent = (brazeId: string) => {
  logger.info("[survicate] set visitor attributes", { brazeId });
  Survicate.setVisitorTraits({ brazeId });
};

export const initSurvicate = async (environment: EnvironmentNames) => {
  logger.info("[survicate] initialising");
  try {
    await Survicate.init({
      workspaceKey: getApiKey(environment),
    });
    logger.info("[survicate] initialisation success");

    const { bzid } = (await fetchMarketingId({})) || {};
    if (bzid) {
      logger.info("[survicate] setting visitor attributes", { bzid });
      setVistorAttributesEvent(bzid);
    }
  } catch (error) {
    logger.error("[survicate] initialisation failed", error);
  }
};
